/**
 * ゲーム内アップデート情報
 *
 * バージョンアップ時は entries の先頭に新しいエントリを追加する。
 */
export interface UpdateEntry {
  version: string;
  lines: string[];
}

export const UPDATE_INFO: { entries: UpdateEntry[] } = {
  entries: [
    {
      version: '1.4.0',
      lines: [
        '・隠しキャラクターが解放されるシステムを追加',
        '・隠しキャラの解放実績を追加',
        '・解放済み隠しキャラが大会に参加するように',
        '・実績一覧画面を追加',
        '・大会の引き分けで再試合が行われるように',
        '・ギブアップ後スキップ不能になるバグを修正',
        '・ボスステージのランダム選択でフリーズするバグを修正',
        '・キャラ選択のパラメータ名の文字色を改善',
        '・ザーグのグラフィックを変更',
      ],
    },
    {
      version: '1.3.1',
      lines: [
        '・実績システムを追加（バトル達成時に通知）',
        '・iOS：バトル開始時にタイトルへ戻るクラッシュを修正',
      ],
    },
    {
      version: '1.3.0',
      lines: [
        '・キャンペーン：最終ステージに強敵が登場',
        '・キャンペーン：ボスを撃破したキャラクターに👑マークを表示',
        '・AI：達人（Lv6）を追加',
        '・マップ・BGM選択にランダムを追加',
        '・観戦モード：タイムアップ時に対戦が終了しないバグを修正',
        '・iOS：縦向き起動でボタンが反応しないバグを修正',
        '・BGMの選択肢の名称を変更',
      ],
    },
    {
      version: '1.2.2',
      lines: [
        '・サバイバル：キャラ別の最高連勝数を記録・表示',
        '・ホームに戻るとBGMが鳴り続ける問題を修正',
        '・バトル中カメラ演出が戻らなくなることがある問題を修正',
      ],
    },
    {
      version: '1.2.1',
      lines: [
        '・キャンペーン：複数戦繰り返すと落ちる問題を修正',
        '・キャンペーン：勝利後にステージ選択に戻るよう変更',
        '・iOS版を公開',
      ],
    },
    {
      version: '1.2.0',
      lines: [
        '・コマンドボタンの見た目を変更',
        '・キャンペーン：クリア済みステージを再プレイ可能に',
        '・キャンペーン：ステージ前に敵キャラ紹介を表示',
        '・キャンペーン：ステージごとに専用バトルマップを設定',
        '・観戦モードにBGM・マップ選択を追加',
        '・「ローカル対戦」を「フレンド対戦」に改名',
        '・フレンド対戦の安定性・タイマー表示を改善',
        '・新規バトルマップ4枚追加・マップ固有名称を設定',
        '・アプリサイズを大幅削減',
      ],
    },
    {
      version: '1.1.0',
      lines: [
        '・バトルマップをキャラ選択画面で選べるように',
        '・サバイバルでBGMに連動してマップが切り替わるように',
        '・タイトル画面にアップデート情報ボタンを追加',
        '・キャンペーンステージ1のチュートリアルを改善',
        '・コマンド入力カウントダウンを見やすい位置に移動',
        '・CPU難易度「最強」を「熟練」にリネーム',
        '・ローカル対戦のバグ修正・安定性改善',
      ],
    },
    {
      version: '1.0.5',
      lines: [
        '・サバイバルでマップがBGMと連動して切り替わるように',
        '・キャラ選択画面でバトルマップを選択できるように',
        '・更新情報ボタンをタイトル画面に追加',
        '・コマンド入力カウントダウンを見やすい位置に移動',
        '・タイムアウト時のデフォルトコマンドを武器攻撃に変更',
        '・バージョン表示を月単位（YYYY/MM）に変更',
      ],
    },
    {
      version: '1.0.4',
      lines: [
        '・スプラッシュ画面をリニューアル',
        '・BGM音量カーブを改善（低音量の調整がしやすく）',
        '・各画面でボタン選択時にSEが鳴るように',
        '・スライダーバーの表示バグを修正',
        '・特殊攻撃missアニメーションを修正',
        '・CPU戦の制限時間切れバグを修正',
        '・ローカル対戦キャラ選択「戻る」時のバグを修正',
      ],
    },
    {
      version: '1.0.0',
      lines: [
        '・初回リリース',
      ],
    },
  ],
};
